import React from "react";
import { useData } from "../context/DataContext";
import useUserData from "./useGraphUserData";

export default function useUserCommande() {
	const { commandeEnCours } = useData();
	const { userData } = useUserData();

	const [userCommande, setUserCommande] = React.useState(null);

	const fetchUserCommande = React.useCallback(async () => {
		if (!userCommande && commandeEnCours && userData) {
			setUserCommande(
				commandeEnCours[userData.id]
					? JSON.parse(commandeEnCours[userData.id])
					: []
			);
		}
	}, [userCommande, commandeEnCours, userData]);

	React.useEffect(() => {
		fetchUserCommande();
	}, [fetchUserCommande]);

	return { userCommande };
}
